import { render, staticRenderFns } from "./ConfiguradorItemRestaurante.vue?vue&type=template&id=49afd5ac&scoped=true"
import script from "./ConfiguradorItemRestaurante.vue?vue&type=script&lang=js"
export * from "./ConfiguradorItemRestaurante.vue?vue&type=script&lang=js"
import style0 from "./ConfiguradorItemRestaurante.vue?vue&type=style&index=0&id=49afd5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afd5ac",
  null
  
)

export default component.exports